import { render } from "./SectionText.vue?vue&type=template&id=95be30ea"
import script from "./SectionText.vue?vue&type=script&lang=js"
export * from "./SectionText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__